<template>
	<div
		id="offer-management"
		:class="[!isWeb ? 'mobile-offer-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="offer-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<OfferTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshOffers="refreshOffers"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { GET_ALL_OFFERS, GET_ALL_OFFER_STATUS } from '@/store/modules/offerManagement/actions';
import TableFilter from '@/components/modules/Offer/OfferManagement/TableFilter/TableFilter.vue';
import OfferTable from '@/components/modules/Offer/OfferManagement/Table/Table.vue';

export default {
	name: 'OfferManagement',
	components: { TableFilter, OfferTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshOffers();
		this.getAllOfferStatus({ vm: this });
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('offerManagement', {
			getOffers: GET_ALL_OFFERS,
			getAllOfferStatus: GET_ALL_OFFER_STATUS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshOffers();
		},
		searchFromInput(params) {
			this.searchParams = params;
			this.page = 1;
			this.refreshOffers();
		},
		orderByHeader(param) {
			if (this?.headerSelected === param) {
				if (this.orderSelected === 'ASC') {
					this.orderSelected = 'DESC';
				} else {
					this.orderSelected = 'ASC';
				}
			} else {
				this.orderSelected = 'DESC';
			}
			this.headerSelected = param;
			this.refreshOffers();
		},
		refreshOffers() {
			let params = `?limit=20&page=${this.page}`;
			if (this.searchParams) params += `&search=${this.searchParams}`;
			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getOffers({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'OfferManagement.scss';
</style>
